import { render, staticRenderFns } from "./allot-provider.vue?vue&type=template&id=4418a116&scoped=true"
import script from "./allot-provider.vue?vue&type=script&lang=ts"
export * from "./allot-provider.vue?vue&type=script&lang=ts"
import style0 from "./allot-provider.vue?vue&type=style&index=0&id=4418a116&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4418a116",
  null
  
)

export default component.exports